const getMoodString = (
  mood: string,
  index: number,
  moodLength: number
): string => {
  if (index === 0 && moodLength > 1) return `${mood}, `;

  return mood;
};

export default getMoodString;
